namespace GeniuzPOS.AdvPromo {
    export enum FreeLpFg {
        FreeLpFg1 = 0,
        FreeLpFg2 = 1
    }
    Serenity.Decorators.registerEnumType(FreeLpFg, 'GeniuzPOS.AdvPromo.FreeLpFg');
}
